// angular
// 	.module("HeroPRO")
// 	.controller("NotificationFooterController", notificationFooterController);

import angular from 'angular';
import _ from 'lodash';
import './notificationFooter.scss';


/* @ngInject */
export default function notificationFooterController($q, $uibModal, $analytics, NotificationUtility, NotificationCenterFactory, $window, $state, $scope, UserData, HPNotificationPriority, BenjiUserFactory, $rootScope, HISWizardFactory) {
    const vm = this;
    let notificationFooter;
    let wrappedNotificationFooter;
    let modalInstance = null;

    vm.footerHeight = 0;
    vm.loaded = false;
    vm.notificationMessage = '';
    vm.notificationFooterVisible = true;
    vm.notificationColor = 'default'; // default || warning
    vm.hisTrainingMandate = {};

    $scope.$on('loadNotifications', () => {
        init();
    });

    $scope.$on('CSLB-Qualifier-Fixed', () => {
        vm.notificationFooterVisible = false;
    });
    /*= =======================================
       =            Public Functions            =
       ======================================== */

    vm.openNotificationModal = function (event, category) {
        $analytics.eventTrack(event, { category });
        if (vm.hisTrainingMandate && (vm.hisTrainingMandate.IsTrainingRequired || vm.hisTrainingMandate.IsLicenseEntryRequired ||
            vm.hisTrainingMandate.IsLicenseExpired || vm.hisTrainingMandate.IsLicenseExpiring || vm.hisTrainingMandate.IsLicenseSuspended
            )) {
            HISWizardFactory.openHISWizardModal(false);
        } else {
            openNotificationsCenterModal();
        }
    };

    /* -----  End of Public Functions  ------*/

    /*= ========================================
       =            Private Functions            =
       ========================================= */

    function init() {
        notificationFooter = $window.document.getElementsByClassName('notification-footer');
        wrappedNotificationFooter = angular.element(notificationFooter);

        const animation = 'bottom 0.5s ease-in-out';
        wrappedNotificationFooter.css('-webkit-transition', animation);
        wrappedNotificationFooter.css('-moz-transition', animation);
        wrappedNotificationFooter.css('-o-transition', animation);
        wrappedNotificationFooter.css('-ms-transition', animation);
        wrappedNotificationFooter.css('transition', animation);

        getNotificationMessage();
    }

    function getNotificationMessage() {
        const requests = [
            UserData.getHISTrainingMandate(),
            NotificationCenterFactory.getNotifications(),
        ];

        $q.all(requests).then((responses) => {
            $rootScope.$broadcast('HideMainSpinner');

            const hisTrainingMandateResponse = responses[0];
            const notificationResponse = responses[1];
            const hasMandatoryActions = notificationResponse != null && _.some(notificationResponse, ai => ai.ActionItemTypeId == 14 || ai.ActionItemTypeId == 18 || ai.ActionItemTypeId == 21);
            vm.hisTrainingMandate = hisTrainingMandateResponse;

            if (BenjiUserFactory.getIsBenjiUserOnly() && BenjiUserFactory.getShouldBenjiRedirect() && !hasMandatoryActions) {
                BenjiUserFactory.redirectUserToBenji();
            } else {
                if (hisTrainingMandateResponse.IsTrainingRequired || hisTrainingMandateResponse.IsLicenseEntryRequired) {
                    const daysLeftToComplete = UserData.getTrainingDaysRemaining(hisTrainingMandateResponse.TrainingRequiredBy);
                    if (!hisTrainingMandateResponse.IsTrainingRequired) {
                        vm.notificationMessage = `HIS License # Required. You have ${daysLeftToComplete} days to complete this.`;
                    } else {
                        vm.notificationMessage = `HIS Training Required. You have ${daysLeftToComplete} days to complete this training.`;
                    }
                    vm.notificationFooterVisible = true;
                    showFooter();
                } else if(hisTrainingMandateResponse.IsLicenseExpiring || hisTrainingMandateResponse.IsLicenseExpired || hisTrainingMandateResponse.IsLicenseSuspended) {
                    if(hisTrainingMandateResponse.IsLicenseExpiring) {
                        vm.notificationMessage = "It looks like your HIS license is expiring soon, click here to find out what steps you need to take.";
                    }
                    else if(hisTrainingMandateResponse.IsLicenseExpired) {
                        vm.notificationMessage = "It looks like your HIS license is expired, click here to find out what steps you need to take.";
                    }
                    else if(hisTrainingMandateResponse.IsLicenseSuspended) {
                        vm.notificationMessage = "It looks like there is an issue with your HIS license. Please, click here to learn more.";
                    }

                    vm.notificationFooterVisible = true;
                    showFooter();                    
                }
                else if (notificationResponse.length > 0) {
                    buildNotifications(notificationResponse);
                }
            }
        });
    }

    function buildNotifications(response) {
        const requiredNotifications = NotificationUtility.buildRequiredNotifications(response);
        const notificationConfiguration = NotificationUtility.buildNotificationConfiguration(response);
        vm.notificationMessage = notificationConfiguration.message;
        vm.notificationColor = notificationConfiguration.color;

        if (requiredNotifications.length > 0 && requiredNotifications[0].Priority === HPNotificationPriority.Mandatory) {
            vm.openNotificationModal('View Notifications', 'Required Nofitication');
        }

        if (vm.notificationMessage === '') {
            vm.loaded = false;
        } else {
            showFooter();
        }
    }

    function showFooter() {
        vm.loaded = true;
        _.delay(() => {
            wrappedNotificationFooter.css('bottom', `-${wrappedNotificationFooter[0].offsetHeight}px`);
            _.delay(() => {
                wrappedNotificationFooter.css('bottom', '0px');
            }, 10);
        }, 10);
    }

    function getNotificationsModalConfiguration(notifications) {
        const config = {
            templateUrl: 'app/notificationCenter/modal/notificationModal.html',
            windowClass: 'notification-modal full-screen',
            controller: 'NotificationModalController',
            controllerAs: 'notificationModal',
            size: 'full-screen',
            animation: false,
            keyboard: true,
        };

        const openNotifications = _.filter(notifications, n => n.Priority === HPNotificationPriority.Mandatory);

        if (openNotifications.length > 0) {
            config.backdrop = 'static';
            config.keyboard = false;
        }
        return config;
    }

    function openNotificationsCenterModal() {
        modalInstance = $uibModal.open(getNotificationsModalConfiguration(NotificationCenterFactory.getNotificationData()));

        modalInstance.result.then((response) => {
            const notification = NotificationCenterFactory.getActiveNotification();

            if (response.result) {
                NotificationCenterFactory.markNotificationComplete(notification.ActionItemId);
            }

            if (notification.CanBeDismissedByUser) {
                notification.showModal = false;
            }

            if (response.errorStatus) {
                $state.go('httpError1', { status: response.errorStatus });
            }

            buildNotifications(NotificationCenterFactory.getNotificationData());
        });
    }
    /* -----  End of Private Functions  ------*/
}



// WEBPACK FOOTER //
// ./src/app/notificationCenter/footer/notificationFooterController.js